"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[3841],{

/***/ 90668:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_19__ = __webpack_require__(47568);
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_21__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_20__ = __webpack_require__(69396);
/* harmony import */ var _builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(34051);
/* harmony import */ var _builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(85893);
/* harmony import */ var _deprecated_ui_common_Flex__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(70821);
/* harmony import */ var _deprecated_ui_common_Text__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(95541);
/* harmony import */ var _deprecated_ui_common_Iconmoon__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(15807);
/* harmony import */ var _deprecated_ui_style_color__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(22147);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(67294);
/* harmony import */ var react_redux__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(2497);
/* harmony import */ var global_Image__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(579);
/* harmony import */ var global_ModalShare__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(41232);
/* harmony import */ var lib_entities_chat_slice__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(10707);
/* harmony import */ var lib_entities_profile__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(333);
/* harmony import */ var antd__WEBPACK_IMPORTED_MODULE_23__ = __webpack_require__(56266);
/* harmony import */ var hooks_useTooltip__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(30627);
/* harmony import */ var constants_app__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(86123);
/* harmony import */ var features_stream_analytics_StreamTabAnalytics__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(99093);
/* harmony import */ var utils_source__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(9486);
/* harmony import */ var _Modals__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__(50700);
/* harmony import */ var _styled__WEBPACK_IMPORTED_MODULE_17__ = __webpack_require__(97986);
/* harmony import */ var _slice__WEBPACK_IMPORTED_MODULE_18__ = __webpack_require__(47225);
/* harmony import */ var _tests_constants__WEBPACK_IMPORTED_MODULE_22__ = __webpack_require__(18278);
/* eslint-disable no-unused-vars */ 























var LS_TOOLTIP_SHARE = "tooltipShare";
function Footer(param) {
    var post = param.post, onComment = param.onComment, _symbol = param.symbol, symbol = _symbol === void 0 ? "" : _symbol, _hideLikers = param.hideLikers, hideLikers = _hideLikers === void 0 ? false : _hideLikers, _isFirstPost = param.isFirstPost, isFirstPost = _isFirstPost === void 0 ? false : _isFirstPost;
    var pageSource = (0,utils_source__WEBPACK_IMPORTED_MODULE_15__/* .getAnalyticsPageSource */ .u)();
    var dispatch = (0,react_redux__WEBPACK_IMPORTED_MODULE_7__/* .useDispatch */ .I0)();
    var ref = (0,react_redux__WEBPACK_IMPORTED_MODULE_7__/* .useSelector */ .v9)(lib_entities_profile__WEBPACK_IMPORTED_MODULE_11__/* .selectors */ .wl), profileData = ref.data;
    var _country = profileData.country, country = _country === void 0 ? "ID" : _country;
    var ref1 = (0,hooks_useTooltip__WEBPACK_IMPORTED_MODULE_12__/* ["default"] */ .Z)(LS_TOOLTIP_SHARE), showShareTolltip = ref1.showTooltip, onCloseShareTooltip = ref1.onCloseTooltip;
    var ref2 = (0,react__WEBPACK_IMPORTED_MODULE_6__.useState)(false), modalShare = ref2[0], showModalShare = ref2[1];
    var ref3 = (0,react__WEBPACK_IMPORTED_MODULE_6__.useState)(false), modalInsight = ref3[0], showModalInsight = ref3[1];
    var ref4 = (0,react__WEBPACK_IMPORTED_MODULE_6__.useState)(false), modalTipping = ref4[0], showModalTipping = ref4[1];
    var ref5 = (0,react__WEBPACK_IMPORTED_MODULE_6__.useState)(false), modalLike = ref5[0], showModalLike = ref5[1];
    var likes = post.likes, replies = post.replies, liked = post.liked, postid = post.postid;
    // TODO: handle logic in footer
    /**
   * - Handle like post -> button after liked/unliked (DONE)
   * - Open modal conversation
   * - Hide tipjar icon if post.userid === current userid
   */ var handleLikePost = function() {
        var action = liked ? _slice__WEBPACK_IMPORTED_MODULE_18__/* .effects.unlikePost */ .Sz.unlikePost : _slice__WEBPACK_IMPORTED_MODULE_18__/* .effects.likePost */ .Sz.likePost;
        // @ts-ignore
        dispatch(action(postid));
    };
    var handleShareToChat = function() {
        var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_19__/* ["default"] */ .Z)(_builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee(chatData) {
            var send, error;
            return _builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        _ctx.next = 2;
                        return dispatch(lib_entities_chat_slice__WEBPACK_IMPORTED_MODULE_10__/* .effects.sendBulkChat */ .Sz.sendBulkChat((0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_20__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_21__/* ["default"] */ .Z)({}, chatData), {
                            attachment_url: "",
                            shared_content: {
                                type: "SHARED_CONTENT_TYPE_STREAM",
                                id: post.postid
                            }
                        })));
                    case 2:
                        send = _ctx.sent;
                        error = send.payload.error;
                        if (!error) {
                            showModalShare(false);
                        }
                    case 5:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        }));
        return function handleShareToChat(chatData) {
            return _ref.apply(this, arguments);
        };
    }();
    var handleClickShare = function() {
        if (pageSource) {
            features_stream_analytics_StreamTabAnalytics__WEBPACK_IMPORTED_MODULE_14__/* ["default"].common.Action.clickShareButton */ .ZP.common.Action.clickShareButton(pageSource);
        }
        showModalShare(true);
    };
    var handleClickTip = function() {
        if (pageSource) {
            features_stream_analytics_StreamTabAnalytics__WEBPACK_IMPORTED_MODULE_14__/* ["default"].common.Action.clickTipping */ .ZP.common.Action.clickTipping({
                pageSource: pageSource,
                streamId: post.postid,
                userId: post.userid
            });
        }
        showModalTipping(true);
    };
    var urlToShare = (0,react__WEBPACK_IMPORTED_MODULE_6__.useMemo)(function() {
        var path = !constants_app__WEBPACK_IMPORTED_MODULE_13__/* .PROJECT_FOLDER */ .sP || constants_app__WEBPACK_IMPORTED_MODULE_13__/* .PROJECT_FOLDER */ .sP === "/" ? "/" : "/".concat(constants_app__WEBPACK_IMPORTED_MODULE_13__/* .PROJECT_FOLDER */ .sP, "/");
        return "".concat(window.location.origin).concat(path, "post/").concat(post.postid);
    }, [
        post
    ]);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(_styled__WEBPACK_IMPORTED_MODULE_17__/* .FooterContainer */ .bk, {
        className: "stream-footer-container",
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(_deprecated_ui_common_Flex__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
                justify: "space-between",
                align: "flex-end",
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(_deprecated_ui_common_Flex__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
                        align: "flex-end",
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)("div", {
                                children: [
                                    !hideLikers ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_deprecated_ui_common_Text__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
                                        as: "a",
                                        className: "likes-info",
                                        onClick: function() {
                                            return showModalLike(true);
                                        },
                                        children: likes > 0 && "".concat(likes, " likes")
                                    }) : null,
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_deprecated_ui_common_Flex__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
                                        padding: "10px 20px 0 0",
                                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_deprecated_ui_common_Iconmoon__WEBPACK_IMPORTED_MODULE_4__/* .IconWrapper */ .a, {
                                            onClick: handleLikePost,
                                            "data-cy": symbol ? _tests_constants__WEBPACK_IMPORTED_MODULE_22__/* .DATA_CY_FOOTER_LIKE_BUTTON_COMPANY */ .KL : _tests_constants__WEBPACK_IMPORTED_MODULE_22__/* .DATA_CY_FOOTER_LIKE_BUTTON */ .l,
                                            children: liked ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(global_Image__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z, {
                                                src: "/icon/post-stream/like-fill.svg",
                                                alt: "Like post filled",
                                                style: {
                                                    width: "20px"
                                                }
                                            }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(global_Image__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z, {
                                                src: "/icon/post-stream/like.svg",
                                                alt: "Like post",
                                                style: {
                                                    width: "20px"
                                                }
                                            })
                                        })
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_deprecated_ui_common_Flex__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
                                padding: "0 20px 0 0",
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(antd__WEBPACK_IMPORTED_MODULE_23__/* ["default"] */ .Z, {
                                    placement: "top",
                                    title: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_deprecated_ui_common_Text__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
                                        color: _deprecated_ui_style_color__WEBPACK_IMPORTED_MODULE_5__/* ["default"].light */ .Z.light,
                                        family: "bold",
                                        size: "12px",
                                        height: "22px",
                                        onClick: onCloseShareTooltip,
                                        children: "Share to friends"
                                    }),
                                    defaultVisible: showShareTolltip && isFirstPost,
                                    visible: showShareTolltip && isFirstPost,
                                    overlayClassName: "tooltip-overlay-green",
                                    overlayInnerStyle: {
                                        background: _deprecated_ui_style_color__WEBPACK_IMPORTED_MODULE_5__/* ["default"].primary */ .Z.primary,
                                        padding: "6px 8px"
                                    },
                                    zIndex: 99,
                                    arrowPointAtCenter: true,
                                    onVisibleChange: function(open) {
                                        return onCloseShareTooltip();
                                    },
                                    getPopupContainer: function() {
                                        return(// @ts-expect-error
                                        document.getElementsByClassName("stream-footer-container")[0]);
                                    },
                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_deprecated_ui_common_Iconmoon__WEBPACK_IMPORTED_MODULE_4__/* .IconWrapper */ .a, {
                                        onClick: handleClickShare,
                                        "data-cy": symbol ? _tests_constants__WEBPACK_IMPORTED_MODULE_22__/* .DATA_CY_FOOTER_SHARE_BUTTON_COMPANY */ .H9 : _tests_constants__WEBPACK_IMPORTED_MODULE_22__/* .DATA_CY_FOOTER_SHARE_BUTTON */ .On,
                                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(global_Image__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z, {
                                            src: "/icon/post-stream/share.svg",
                                            alt: "Share post",
                                            style: {
                                                width: "20px"
                                            }
                                        })
                                    })
                                })
                            }),
                            post.analytics && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_deprecated_ui_common_Iconmoon__WEBPACK_IMPORTED_MODULE_4__/* .IconWrapper */ .a, {
                                padding: "0 20px 0 0",
                                onClick: function() {
                                    return showModalInsight(true);
                                },
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_deprecated_ui_common_Iconmoon__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {
                                    className: "icon-new_analytics",
                                    size: "16px",
                                    color: _deprecated_ui_style_color__WEBPACK_IMPORTED_MODULE_5__/* ["default"].dimgray */ .Z.dimgray,
                                    hoverColor: _deprecated_ui_style_color__WEBPACK_IMPORTED_MODULE_5__/* ["default"].dimgray */ .Z.dimgray
                                })
                            }),
                            !post.is_author && country === "ID" && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_deprecated_ui_common_Iconmoon__WEBPACK_IMPORTED_MODULE_4__/* .IconWrapper */ .a, {
                                padding: "0 20px 0 0",
                                onClick: handleClickTip,
                                "data-cy": symbol ? _tests_constants__WEBPACK_IMPORTED_MODULE_22__/* .DATA_CY_FOOTER_TIP_BUTTON_COMPANY */ .tJ : _tests_constants__WEBPACK_IMPORTED_MODULE_22__/* .DATA_CY_FOOTER_TIP_BUTTON */ .vI,
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(global_Image__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z, {
                                    src: "/icon/post-stream/icon-tip.svg",
                                    alt: "Icon Tip",
                                    style: {
                                        width: "20px"
                                    }
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(_deprecated_ui_common_Flex__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
                        onClick: onComment,
                        style: {
                            alignItems: "flex-end"
                        },
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_deprecated_ui_common_Text__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
                                padding: "0 8px 0",
                                children: parseInt(replies, 10) > 0 && replies
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_deprecated_ui_common_Iconmoon__WEBPACK_IMPORTED_MODULE_4__/* .IconWrapper */ .a, {
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(global_Image__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z, {
                                    src: "/icon/post-stream/comment.svg",
                                    alt: "Icon Comment New",
                                    style: {
                                        width: "20px"
                                    },
                                    "data-cy": symbol ? _tests_constants__WEBPACK_IMPORTED_MODULE_22__/* .DATA_CY_STREAM_COMMENT_ICON_COMPANY */ .dJ : _tests_constants__WEBPACK_IMPORTED_MODULE_22__/* .DATA_CY_STREAM_COMMENT_ICON */ .Vi
                                })
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(global_ModalShare__WEBPACK_IMPORTED_MODULE_9__["default"], {
                post: post,
                sendChat: handleShareToChat,
                title: "Share",
                hasCopyButton: true,
                hasRepostButton: post.is_author === 0,
                hasSearchPeople: true,
                hasSocialMedia: true,
                hasShareInput: true,
                urlToShare: urlToShare,
                visible: modalShare,
                onCancel: function() {
                    return showModalShare(false);
                }
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_Modals__WEBPACK_IMPORTED_MODULE_16__/* .ModalInsight */ .eV, {
                visible: modalInsight,
                post: post,
                onCancel: function() {
                    return showModalInsight(false);
                }
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_Modals__WEBPACK_IMPORTED_MODULE_16__/* .ModalTipping */ .MW, {
                streamId: postid,
                userId: post.userid,
                username: post.username,
                avatar: post.avatar,
                visible: modalTipping,
                onCancel: function() {
                    return showModalTipping(false);
                }
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_Modals__WEBPACK_IMPORTED_MODULE_16__/* .ModalLike */ .gU, {
                likes: likes,
                streamId: postid,
                visible: modalLike,
                onCancel: function() {
                    return showModalLike(false);
                }
            })
        ]
    });
}
/* harmony default export */ __webpack_exports__["default"] = (Footer);


/***/ }),

/***/ 82592:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var _deprecated_ui_common_Flex__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(70821);
/* harmony import */ var _deprecated_ui_common_Text__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(95541);
/* harmony import */ var _deprecated_ui_common_Iconmoon__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(15807);




function PinnedLabel(param) {
    var isCompanyPinnedPost = param.isCompanyPinnedPost, _text = param.text, text = _text === void 0 ? "Pinned Post" : _text, _marginBottom = param.marginBottom, marginBottom = _marginBottom === void 0 ? "16px" : _marginBottom;
    var color = isCompanyPinnedPost ? "#858585" : "#e32072";
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_deprecated_ui_common_Flex__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z, {
        // @ts-expect-error
        ml: isCompanyPinnedPost ? "0px" : "50px",
        align: "center",
        mb: marginBottom,
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_deprecated_ui_common_Iconmoon__WEBPACK_IMPORTED_MODULE_3__/* .IconWrapper */ .a, {
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_deprecated_ui_common_Iconmoon__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
                    className: "icon-toolbar_pinned",
                    size: "16px",
                    color: color
                })
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_deprecated_ui_common_Text__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
                ml: isCompanyPinnedPost ? "4px" : "8px",
                color: color,
                children: isCompanyPinnedPost ? "Pinned Post by Stockbit" : text
            })
        ]
    });
}
/* harmony default export */ __webpack_exports__["Z"] = (PinnedLabel);


/***/ }),

/***/ 3841:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ StreamWidget_Post; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_to_consumable_array.mjs + 2 modules
var _to_consumable_array = __webpack_require__(36305);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/next/dynamic.js
var dynamic = __webpack_require__(5152);
var dynamic_default = /*#__PURE__*/__webpack_require__.n(dynamic);
// EXTERNAL MODULE: ./src/@deprecated-ui/common/Flex.js
var Flex = __webpack_require__(70821);
// EXTERNAL MODULE: ./src/@deprecated-ui/common/Text.js
var Text = __webpack_require__(95541);
// EXTERNAL MODULE: ./src/global/ImageSlider/index.tsx + 7 modules
var ImageSlider = __webpack_require__(9649);
// EXTERNAL MODULE: ./src/global/Image/index.js
var Image = __webpack_require__(579);
// EXTERNAL MODULE: ./node_modules/react-redux/es/index.js + 17 modules
var es = __webpack_require__(2497);
// EXTERNAL MODULE: ./src/lib/entities/credentials.js + 4 modules
var credentials = __webpack_require__(21671);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./src/global/StreamWidget/PollingContainer/index.tsx + 2 modules
var PollingContainer = __webpack_require__(78690);
// EXTERNAL MODULE: ./src/global/StreamWidget/TargetPriceContainer/index.tsx + 2 modules
var TargetPriceContainer = __webpack_require__(18562);
// EXTERNAL MODULE: ./src/global/StreamWidget/TextContent/index.tsx
var TextContent = __webpack_require__(13683);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(69396);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_without_properties.mjs + 1 modules
var _object_without_properties = __webpack_require__(99534);
// EXTERNAL MODULE: ./src/@deprecated-ui/common/Avatar.js
var Avatar = __webpack_require__(57788);
// EXTERNAL MODULE: ./src/@deprecated-ui/_style/color.js
var color = __webpack_require__(22147);
// EXTERNAL MODULE: ./node_modules/next/link.js
var next_link = __webpack_require__(41664);
var link_default = /*#__PURE__*/__webpack_require__.n(next_link);
// EXTERNAL MODULE: ./src/global/Labels/index.tsx + 5 modules
var Labels = __webpack_require__(94493);
// EXTERNAL MODULE: ./src/constants/api.js
var api = __webpack_require__(37213);
// EXTERNAL MODULE: ./src/utils/general.js
var general = __webpack_require__(42227);
// EXTERNAL MODULE: ./src/global/StreamWidget/Post/styled.ts
var styled = __webpack_require__(97986);
;// CONCATENATED MODULE: ./src/global/StreamWidget/Post/Comment.tsx














function Comment(_param) {
    var comment = _param.comment, props = (0,_object_without_properties/* default */.Z)(_param, [
        "comment"
    ]);
    var avatar = comment.avatar, content = comment.content, maskedHtml = comment.mask_html, username = comment.username, created = comment.created_display, official = comment.official, isVerified = comment.is_verified, privilege = comment.user_priv;
    var avatarUrl = avatar.startsWith("http") ? avatar : "".concat(api/* AVATAR_URL */.q$, "/").concat(avatar);
    // Note :
    // From backend in stream post the type of official param is number
    // but stream post inside the last_reply have official param type string
    var isOfficial = official > 0 || isVerified;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, props), {
        style: {
            cursor: "pointer"
        },
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(styled/* CommentContainer */.bQ, {
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex/* default */.Z, {
                    mb: "10px",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Avatar/* default */.Z, {
                            size: "x-small",
                            padding: "0 10px 0 0",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Image/* default */.Z, {
                                alt: "imageProfile",
                                src: avatarUrl,
                                onError: function(e) {
                                    return (0,general/* handleErrorAvatar */.Tk)(e, username);
                                }
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex/* default */.Z, {
                                    align: "center",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                            href: "/".concat(username),
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(styled/* TextHeader */.Y, {
                                                family: "bold",
                                                size: "14px",
                                                children: username
                                            })
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Labels/* LabelVerifiedAccount */.uC, {
                                            deprecatedVerifiedStatus: isOfficial,
                                            verifiedStatus: comment === null || comment === void 0 ? void 0 : comment.verified_status
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Labels/* LabelAdmin */.SH, {
                                            privilege: privilege
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(styled/* TextHeader */.Y, {
                                    size: "12px",
                                    color: color/* default.midgray */.Z.midgray,
                                    children: created
                                })
                            ]
                        })
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(TextContent/* default */.Z, {
                    content: content,
                    maskedHtml: maskedHtml,
                    style: {
                        marginBottom: "0px"
                    },
                    needParsed: false
                })
            ]
        })
    }));
}
/* harmony default export */ var Post_Comment = (Comment);

// EXTERNAL MODULE: ./src/global/StreamWidget/Post/DocumentContainer.tsx
var DocumentContainer = __webpack_require__(55424);
// EXTERNAL MODULE: ./src/global/StreamWidget/Post/Header.tsx
var Header = __webpack_require__(5373);
// EXTERNAL MODULE: ./src/global/StreamWidget/Post/PinnedLabel.tsx
var PinnedLabel = __webpack_require__(82592);
// EXTERNAL MODULE: ./src/global/StreamWidget/Post/RepostBox.tsx
var RepostBox = __webpack_require__(38294);
// EXTERNAL MODULE: ./src/global/StreamWidget/Post/TitleContent.tsx + 1 modules
var TitleContent = __webpack_require__(41447);
// EXTERNAL MODULE: ./src/global/StreamWidget/Post/YoutubePlayer.tsx
var YoutubePlayer = __webpack_require__(74132);
// EXTERNAL MODULE: ./src/global/StreamWidget/Post/Footer.tsx
var Footer = __webpack_require__(90668);
;// CONCATENATED MODULE: ./src/global/StreamWidget/Post/index.tsx
/* eslint-disable react/require-default-props */ /* eslint-disable indent */ /* eslint-disable camelcase */ 





















var GuestFooter = dynamic_default()(function() {
    return __webpack_require__.e(/* import() */ 4597).then(__webpack_require__.bind(__webpack_require__, 4597));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(4597)
            ];
        }
    },
    ssr: false,
    loading: function() {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {});
    }
});
var FollowingActivity = dynamic_default()(function() {
    return __webpack_require__.e(/* import() */ 81895).then(__webpack_require__.bind(__webpack_require__, 81895));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(81895)
            ];
        }
    },
    ssr: false,
    loading: function() {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {});
    }
});
function Post(param) {
    var post = param.post, onComment = param.onComment, _pinned = param.pinned, pinned = _pinned === void 0 ? false : _pinned, _showLatestComment = param.showLatestComment, showLatestComment = _showLatestComment === void 0 ? true : _showLatestComment, _hasFollowingActivity = param.hasFollowingActivity, hasFollowingActivity = _hasFollowingActivity === void 0 ? true : _hasFollowingActivity, _expandContent = param.expandContent, expandContent = _expandContent === void 0 ? false : _expandContent, _isFirstPost = param.isFirstPost, isFirstPost = _isFirstPost === void 0 ? false : _isFirstPost, _isSinglePost = param.isSinglePost, isSinglePost = _isSinglePost === void 0 ? false : _isSinglePost, _highlightWord = param.highlightWord, highlightWord = _highlightWord === void 0 ? "" : _highlightWord, _symbol = param.symbol, symbol = _symbol === void 0 ? "" : _symbol, entryPoint = param.entryPoint, dataCyName = param.dataCyName;
    var ref, ref1;
    var content = post.content, content_original = post.content_original, images = post.images, attachment = post.attachment, polling = post.polling, target_price = post.target_price, last_reply = post.last_reply, mask_html = post.mask_html, reposted = post.reposted, repostedfrom = post.repostedfrom, title = post.title, titleurl = post.titleurl, images_data = post.images_data, image_frame_type = post.image_frame_type, followingActivity = post.following_activity, isAuthor = post.is_author;
    var isLoggedIn = (0,es/* useSelector */.v9)(credentials/* selectors */.wl).isLoggedIn;
    var imagesData = (0,react.useMemo)(function() {
        var listImage = (images === null || images === void 0 ? void 0 : images.length) > 0 && images[0] !== "" ? images.map(function(i) {
            return {
                image: i
            };
        }) : [];
        listImage = listImage.filter(function(i) {
            var exist = images_data.find(function(img) {
                return img.image === i.image;
            });
            return !exist;
        });
        listImage = (0,_to_consumable_array/* default */.Z)(listImage).concat((0,_to_consumable_array/* default */.Z)(images_data));
        return listImage;
    }, [
        post
    ]);
    var isHaveImage = Boolean((imagesData === null || imagesData === void 0 ? void 0 : imagesData.length) > 0 && ((ref = imagesData[0]) === null || ref === void 0 ? void 0 : ref.image));
    var showFollowingActivity = (followingActivity === null || followingActivity === void 0 ? void 0 : (ref1 = followingActivity.users) === null || ref1 === void 0 ? void 0 : ref1.length) > 0 && hasFollowingActivity;
    var autoplayYoutube = !isSinglePost;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(styled/* StreamBoxContainer */.Vj, {
        "data-cy": dataCyName,
        children: [
            pinned && /*#__PURE__*/ (0,jsx_runtime.jsx)(PinnedLabel/* default */.Z, {
                isCompanyPinnedPost: entryPoint === "symbol"
            }),
            showFollowingActivity && /*#__PURE__*/ (0,jsx_runtime.jsx)(FollowingActivity, {
                data: followingActivity
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Header/* default */.Z, {
                post: post,
                isLoggedIn: isLoggedIn,
                entryPoint: entryPoint,
                symbol: symbol
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(styled/* ContentWrapper */.vs, {
                children: [
                    (polling === null || polling === void 0 ? void 0 : polling.length) && isLoggedIn > 0 ? /*#__PURE__*/ (0,jsx_runtime.jsx)(PollingContainer/* default */.Z, {
                        post: post,
                        isSinglePost: isSinglePost,
                        isTextDefaultExpand: expandContent,
                        highlightWord: highlightWord
                    }) : /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(styled/* TextContainer */.lU, {
                                children: [
                                    title && titleurl && /*#__PURE__*/ (0,jsx_runtime.jsx)(TitleContent/* default */.Z, {
                                        title: title,
                                        highlightWord: highlightWord,
                                        titleUrl: titleurl
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(TextContent/* default */.Z, {
                                        content: content,
                                        maskedHtml: mask_html,
                                        isDefaultExpand: expandContent,
                                        highlightWord: highlightWord
                                    }),
                                    post.newsfeed_source && /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex/* default */.Z, {
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Image/* default */.Z, {
                                                alt: post.newsfeed_label,
                                                src: post.newsfeed_img,
                                                style: {
                                                    width: "16px",
                                                    marginRight: "8px"
                                                }
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                                                size: "12px",
                                                children: post.newsfeed_label
                                            })
                                        ]
                                    })
                                ]
                            }),
                            isHaveImage ? /*#__PURE__*/ (0,jsx_runtime.jsx)(ImageSlider/* default */.Z, {
                                images: imagesData,
                                frameType: image_frame_type,
                                isSinglePost: isSinglePost
                            }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(YoutubePlayer/* default */.Z, {
                                content: content_original,
                                autoplay: autoplayYoutube
                            }),
                            isLoggedIn ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                                children: [
                                    (attachment === null || attachment === void 0 ? void 0 : attachment.length) > 0 && /*#__PURE__*/ (0,jsx_runtime.jsx)(DocumentContainer/* default */.Z, {
                                        documents: attachment
                                    }),
                                    (target_price === null || target_price === void 0 ? void 0 : target_price.length) > 0 && /*#__PURE__*/ (0,jsx_runtime.jsx)(TargetPriceContainer/* default */.Z, {
                                        targetPrice: target_price[0],
                                        postid: post.postid,
                                        isAuthor: isAuthor
                                    })
                                ]
                            }) : null
                        ]
                    }),
                    reposted > 0 && isLoggedIn && /*#__PURE__*/ (0,jsx_runtime.jsx)(RepostBox/* default */.Z, {
                        post: repostedfrom
                    }),
                    isLoggedIn ? /*#__PURE__*/ (0,jsx_runtime.jsx)(Footer["default"], {
                        post: post,
                        onComment: onComment,
                        isFirstPost: isFirstPost,
                        symbol: symbol
                    }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(GuestFooter, {
                        post: post
                    })
                ]
            }),
            isLoggedIn && showLatestComment && last_reply && Object.keys(last_reply).length > 0 && /*#__PURE__*/ (0,jsx_runtime.jsx)(Post_Comment, {
                comment: last_reply,
                onClick: onComment
            })
        ]
    });
}
/* harmony default export */ var StreamWidget_Post = (Post);


/***/ })

}]);